import {css, view} from '@sail/ui/deprecated';
import {useTheme} from '../ThemeProvider';
import {useUniversalHelpDotComDesign} from '../FeatureFlagsProvider';

type Props = {
  name: string;
  size?: string;
  borderRadius?: string;
};

export const NamedAvatar = ({
  name,
  size = '28px',
  borderRadius = '50%',
}: Props) => {
  const theme = useTheme();
  const useDotComDesign = useUniversalHelpDotComDesign();

  if (useDotComDesign) {
    return null;
  }

  return (
    <view.div
      data-testid="named-avatar"
      role="avatar"
      css={{
        width: css.value(size),
        height: css.value(size),
        borderRadius: css.value(borderRadius),
        background: css.value(
          `linear-gradient(-45deg, ${theme.avatarGradientStart}, ${theme.avatarGradientEnd})`,
        ),
        overflow: 'hidden',
      }}
    >
      <view.span
        css={{
          width: css.value(size),
          height: css.value(size),
          color: css.value(theme.onBrandTextColor),
          stack: 'y',
          alignX: 'center',
          alignY: 'center',
        }}
      >
        {name[0].toUpperCase()}
      </view.span>
    </view.div>
  );
};

export default NamedAvatar;
